import React, { useRef } from "react";
import { useValidate } from "formvalidation/hooks";
import { saveOrCancel } from "utilities/inputUtils";
import { InputBase } from "components/Atoms/formInputs/InputBase";

interface Props {
  focusOnMount?: boolean
  value: string
  onChanged: (newAbaRoutingNumber: string) => void
  onEnter?: () => void
  onEsc?: () => void

  validatorKey: string
}

const AbaRoutingNumberInput = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const isValidInput = (input: string) => {
    if (input.trim().length === 0) return true;

    return /^\d+$/.test(input) &&
      input.length === serverReference.constants.bankAccount.exactAbaRoutingNumberLength;
  };
  const validate = async (input: string) => {
    const isValid = isValidInput(input);
    return isValid;
  };

  const formatInput = (input: string, e?) => {
    const sanitizedInput = input
      .trim()
      .replace(/\D/g, "")
      .substring(0, serverReference.constants.bankAccount.exactAbaRoutingNumberLength);

    if (isValidInput(sanitizedInput)) {
      e?.preventDefault();
      props.onChanged(sanitizedInput);
      return sanitizedInput;
    }

    return false;
  };

  const onPaste = (e) => {
    const text: string = e.clipboardData.getData("text").trim();
    formatInput(text, e);
  };

  const onBlur = () => {
    formatInput(props.value);
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.BankAccount.RoutingNumber,
    value: props.value,
    validate: validate,
    ref: inputRef
  })

  return <InputBase
    ref={inputRef}
    value={props.value}
    maxLength={serverReference.constants.bankAccount.exactAbaRoutingNumberLength}
    error={validation.error.hasError}
    onBlur={onBlur}
    onPaste={onPaste}
    onChange={props.onChanged}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    placeholder="000000000"
    focusOnMount={props.focusOnMount}
  />;
};

export default AbaRoutingNumberInput;